export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const SET_KEYCLOAK = 'SET_KEYCLOAK'
export const USER_INFO = 'USER_INFO'
export const MOBILE_URL = 'MOBILE_URL'
export const INIT_KEYCLOAK = 'INIT_KEYCLOAK'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const GET_RESERVATION = 'GET_RESERVATION'
export const SET_RESERVATION = 'SET_RESERVATION'
export const CREATE_RESERVATION = 'CREATE_RESERVATION'
export const DETAIL_RESERVATION = 'DETAIL_RESERVATION'
export const GET_ROOM_DAY = 'GET_ROOM_DAY'
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION'
export const SET_RUNNING = 'SET_RUNNING'
export const SET_POPUP_STATUS = 'SET_POPUP_STATUS'
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION'
export const CHECK_TOKEN_EXPIRE = 'CHECK_TOKEN_EXPIRE'
export const BYPASS_TOKEN = 'BYPASS_TOKEN'
export const SET_CONTEXT = 'SET_CONTEXT'
export const SET_LOBBY_LIST = 'SET_LOBBY_LIST'
export const SET_VROOM_TOKEN = 'SET_VROOM_TOKEN'
export const SAVE_VROOM_TOKEN = 'SAVE_VROOM_TOKEN'
export const SET_CONNECT_LOBBY = 'SET_CONNECT_LOBBY'
export const REMOVE_VROOM_TOKEN = 'REMOVE_VROOM_TOKEN'
export const SET_ANONYMOUS_INFO = 'SET_ANONYMOUS_INFO'
export const SAVE_ANONYMOUS_INFO = 'SAVE_ANONYMOUS_INFO'
export const REMOVE_ANONYMOUS_INFO = 'REMOVE_ANONYMOUS_INFO'
export const CONNECT_SOCKET = 'CONNECT_SOCKET'
export const SET_ANNOUNCEMENT = 'SET_ANNOUNCEMENT'
export const SHOW_POPUP = 'SHOW_POPUP'
export const HIDE_POPUP = 'HIDE_POPUP'
